export const dayNames = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
